// MODULES
import { useCallback, useEffect, useState } from 'react';
import dayjs from 'dayjs';
import durationPlugin from 'dayjs/plugin/duration';
import { DATE_FORMAT } from 'src/constants/api.constants';


dayjs.extend(durationPlugin);
export interface TimerValueI {
    days: number;
    hours: number;
    minutes: number;
    seconds: number;
}

export const timerInitialState: TimerValueI = {
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
};

export function useCountdown(target: string) {
    const [timer, setTimer] = useState<TimerValueI>(timerInitialState);
    const [isFinished, setFinished] = useState(false);
    const endDate = dayjs(target, DATE_FORMAT);

    const calculateTimeLeft = useCallback(() => {
        const diff = endDate.diff(dayjs());
        const duration = dayjs.duration(diff);
        const diffTime = {
            days: endDate.diff(dayjs(), 'days'),
            hours: duration.hours(),
            minutes: duration.minutes(),
            seconds: duration.seconds(),
        };
        setTimer(diffTime);
    }, [endDate]);

    useEffect(() => {
        let interval: any;

        if (dayjs().isBefore(endDate)) {
            interval = setInterval(calculateTimeLeft, 1000);
        } else {
            setFinished(true);
        }

        return () => interval && clearInterval(interval);
    }, [calculateTimeLeft, endDate]);

    return { ...timer, isFinished };
}
